export enum ActionTypeEnum {
  R = "Read",
  C = "Create",
  U = "Update",
  D = "Delete"
}

export const getActionType = () => {
  return [
    {label: ActionTypeEnum.R, value: 'R'},
    {label: ActionTypeEnum.C, value: 'C'},
    {label: ActionTypeEnum.U, value: 'U'},
    {label: ActionTypeEnum.D, value: 'D'},
  ]
}
